const state = {
  all: [],
  porControlador: {},
  porTag: {}
}

const mutations = {
  updateMonitoramentosControlador (state, res) {
    state.porControlador = res.data
  },
  updateMonitoramentosControladorTag (state, res) {
    state.porTag = res.data
  }
}

const actions = {
  listMonitoramentosControlador(context, data) {
    window.axios.get('/api/v2/monitoramentos/controlador/' + data).then((res) => {
      context.commit('updateMonitoramentosControlador', res)
    })
  },
  listMonitoramentosControladorTag(context, data) {
    window.axios.get('/api/v2/monitoramentos/total/tag/controlador/' + data).then((res) => {
      context.commit('updateMonitoramentosControladorTag', res)
    })
  }
}

export default {
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/Monitoramentos.js